<template>
	<div>
		<PageHeaderLayout :isBack="true">
			<div class="main-page-content">
				<el-row>
					<el-col :span="4">
						<inSiderMenu @goTo="goTo" :category="this.$route.query.category" />
					</el-col>
					<el-col :span="20" style="padding: 0 30px; min-width: 500px">
						<el-row class="steps">
							<el-col :span="24">
								{{ display_name }}
							</el-col>
						</el-row>
						<div v-show="inSiderName == 'basicInfo'">
							<el-form ref="form" :model="form" 
                            :rules="this.$route.query.category == 'channel' ? channelRules : rules"
                            label-width="100px"
                            class="bill-info-form"
                            :label-position="'top'"
              >
                <el-row>
                  <el-col :span="12">
                    <div class="bill-info">
                      <el-form-item prop="name">
                        <template slot="label">
                          <div class="bill-info-title">企业名称</div>
                        </template>
                        <el-input @input="formatCompany" v-model="form.name" :disabled="is_edit"/>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="bill-info">
                      <el-form-item prop="company_phone">
                        <template slot="label">
                          <div class="bill-info-title">企业电话</div>
                        </template>
                        <el-input
                          v-model="form.company_phone"
                          :disabled="is_edit"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <div class="bill-info">
                      <el-form-item prop="taxpayer">
                        <template slot="label">
                          <div class="bill-info-title">企业税号</div>
                        </template>
                        <el-input v-model="form.taxpayer" :disabled="is_edit"/>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="bill-info">
                      <el-form-item prop="bank">
                        <template slot="label">
                          <div class="bill-info-title">开户行</div>
                        </template>
                        <el-input v-model="form.bank" :disabled="is_edit"/>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <div class="bill-info">
                      <el-form-item prop="address">
                        <template slot="label">
                          <div class="bill-info-title">企业地址</div>
                        </template>
                        <el-input min="4" v-model="form.address" :disabled="is_edit"/>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="bill-info">
                      <el-form-item prop="account">
                        <template slot="label">
                          <div class="bill-info-title">银行账号</div>
                        </template>
                        <el-input v-model="form.account" :disabled="is_edit"/>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row v-if="this.$route.query.category != 'channel'">
                  <el-col :span="12">
                    <div class="bill-info">
                      <el-form-item prop="legal_person">
                        <template slot="label">
                          <div class="bill-info-title">公司法人</div>
                        </template>
                        <el-input
                          v-model="form.legal_person"
                          :disabled="is_edit"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="bill-info">
                      <el-form-item prop="legal_phone">
                        <template slot="label">
                          <div class="bill-info-title">法人电话</div>
                        </template>
                        <el-input
                          v-model="form.legal_phone"
                          :disabled="is_edit"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row v-if="this.$route.query.category != 'channel'">
                  <el-col :span="12">
                    <div class="bill-info">
                      <el-form-item
                        label="开票类目："
                        prop="category_list"
                        v-if="this.$route.query.category != 'channel'"
                      >
                        <el-select
                          multiple
                          clearable
                          v-model="form_category_list"
                          :disabled="is_edit"
                          filterable
                          placeholder="请选择开票类目(可多选)"
                        >
                          <el-option
                            v-for="item in categoryList"
                            :key="item.category_id"
                            :label="item.display_name"
                            :value="item.category_id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="bill-info">
                      <el-form-item prop="remark">
                        <template slot="label">
                          <div class="bill-info-title">公司简介</div>
                        </template>
                        <el-input
                          v-model="form.remark"
                          type="textarea"
                          :disabled="is_edit"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row class="mail-wrapper">
                  <div class="bill-mail-info">
                    <el-form-item prop="email">
                      <template slot="label">
                        <div class="mail-info-title">收件地址：</div>
                      </template>
                      <el-input v-model="form.email" :disabled="is_edit"/>
                    </el-form-item>
                    <el-form-item prop="receiver_fullname">
                      <template slot="label">
                        <div class="mail-info-title">收件人：</div>
                      </template>
                      <el-input
                        v-model="form.receiver_fullname"
                        :disabled="is_edit"
                      />
                    </el-form-item>
                    <el-form-item prop="receiver_phone">
                      <template slot="label">
                        <div class="mail-info-title">收件人电话：</div>
                      </template>

                      <el-input
                        v-model="form.receiver_phone"
                        :disabled="is_edit"
                      />
                    </el-form-item>
                  </div>
                </el-row>
                <div class="company-bottom">
                  <el-form-item
                    label="签约类型："
                    prop="sign_type"
                    class="transverse"
                    v-if="this.$route.query.category != 'channel'"
                  >
                    <el-select
                      v-model="form.sign_type"
                      :disabled="true"
                      filterable
                      placeholder="请选择签约类型"
                    >
                      <el-option
                        v-for="item in signTypeList"
                        :key="item.id"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="签约服务类型："
                    prop="category"
                    class="transverse"
                    v-if="this.$route.query.category != 'channel'"
                  >
                    <el-select
                      v-model="form.category"
                      :disabled="is_edit"
                      multiple
                      filterable
                      placeholder="请选择签约服务类型"
                      @change="selectChange"
                    >
                      <el-option
                        v-for="item in enumList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item class="switch" label="到账短信提醒：" prop="is_open_sms"
                                v-if="this.$route.query.category == 'ordinary'">
                    <el-switch
                      v-model=" form.is_open_sms "
                      :disabled="is_edit"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :active-value="1"
                      :inactive-value="0"
                      @change="openSms"
                    >
                    </el-switch>
                  </el-form-item>

                  <el-form-item
                    class="switch"
                    label="支持批量导入："
                    prop="is_import"
                    size="small"
                    v-if="this.$route.query.category == 'ordinary'"
                  >
                    <el-switch
                      v-model="form.is_import"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :active-value="1"
                      :inactive-value="2"
                      @change="openImport"
                      :disabled="is_edit"
                    >
                    </el-switch>
                  </el-form-item>
                  <div v-if="this.$route.query.category == 'channel'">
                    <!-- 固定税率 -->
                    <el-form-item
                      label="设置税率："
                      prop="rate"
                      class="transverse"
                    >
                      <el-input
                        placeholder="请输入税率"
                        v-model="form.rate"
                        :disabled="is_edit"
                      >
                        <template slot="append">%</template>
                      </el-input>
                    </el-form-item>
                  </div>

                  <!-- 阶梯税率 -->
                  <div class="ladderTaxrate" v-show="isladder">
                    <div class="ladder" v-for="(item,index) in gradsdata" :key="index">
                      <el-form-item prop="rate" class="elItem">
                        <el-input
                          placeholder="请输入税率"
                          v-model="item.rate"
                          :disabled="is_edit"
                        >
                          <template slot="append">%</template>
                        </el-input>
                      </el-form-item>
                      <i class="iconfont icon-dayu" style="margin-right: 40px"></i>
                      <el-form-item prop="rate" class="elItem">
                        <el-input
                          v-model="item.money"
                          :disabled="is_edit"
                        >
                        </el-input>
                      </el-form-item>
<!--                      <div style="margin-top: -20px">-->
<!--                        <el-button @click="plusSuiItem(index)" style="margin-right: 20px" type="danger">删除</el-button>-->
<!--                        <el-button @click="addSuiItem" v-show="index==gradsdata.length-1" type="primary">新增</el-button>-->
<!--                      </div>-->
                    </div>
                  </div>

                  <!-- 分界线 -->
                  <div style="margin-left: 70px" v-if="showSL">
                    <span @click="fixation"
                    ><el-radio v-model="radio" label="1"
                    >固定税率</el-radio
                    ></span
                    >
                    <span @click="grads" style="margin-left: 30px"
                    ><el-radio v-model="radio" label="2"
                    >梯度税率</el-radio
                    ></span
                    >
                  </div>
                  <el-form-item
                    prop="contract_file_url"
                    class="bill-info contract"
                  >
                    <template slot="label">
                      <div class="mail-info-title">合同文件：</div>
                      <span class="remarks">支持jpg/png/pdf/doc/docx文件，大小不超过5M</span>
                    </template>
                    <upload-file
                      @remove_file="handleRemoveFile"
                      @return_url="handUploadFile"
                      @before_upload="beforeUpload"
                      :existFile="form.contract_file_url"
                      :title="'合同'"
                      :multiple="'false'"
                      :multiSelection="false"
                      :dir="'bill'"
                      :selectfiles="'contractImportExcel'"
                      :postfiles="'contractExcel'"
                      :ossfile="'ossContractExcelFile'"
                      :fileUrl="dataContractUrl"
                      ref="contract"
                      :max_width="1000"
                    />
                  </el-form-item>
                  <el-form-item
                    prop="risk_url"
                    class="bill-info contract"
					style="height: auto !important"
                    v-if="this.$route.query.category != 'channel'"
                  >
                    <template slot="label">
                      <div class="mail-info-title">风控表：</div>
					<span class="remarks">支持jpg/png文件，最多5张，每张大小不超过2M</span>
                    </template>
                    <upload-files
                      @remove_file="handleRemoveFile"
                      @return_url="handUploadFile"
                      @before_upload="beforeUpload"
                      :existFile="form.risk_url"
                      :title="'风控表'"
                      :multiple="'false'"
                      :multiSelection="true"
                      :dir="'bill'"
                      :selectfiles="'riskImportExcel'"
                      :postfiles="'riskExcel'"
                      :ossfile="'ossRiskExcelFile'"
                      ref="uploadImg"
                      :fileUrl="dataRiskUrl"
                        :max_width="1000"
                      :max_size='5'
                    />
                  </el-form-item>
                </div>
              </el-form>
              <el-row class="save-btn-wrapper">
                <el-button
                  type="primary"
                  size="medium"
                  @click="saveClick('form')"
                  :disabled="this.is_edit"
                >保存
                </el-button
                >
              </el-row>
            </div>

            <div v-show="inSiderName == 'bankAccount'">
              <el-row
                style="height: 36px; display: flex; flex-direction: row-reverse"
              >
                <el-button
                  :disabled="isAbleBankBtn"
                  size="medium"
                  type="primary"
                  @click="generateSubAccount"
                >生成银行账户
                </el-button
                >
              </el-row>
              <ApeTable
                ref="apeTable"
                :data="list"
                :columns="columns"
                :loading="loadingStaus"
                :pagingData="pagingData"
                @switchPaging="switchPaging"
                highlight-current-row
              >
                <el-table-column
                  width="200"
                  header_align="center"
                  align="center"
                  label="操作"
                >
                  <template slot-scope="scope">
                    <span>
                      <el-button
                        size="mini"
                        type="default"
                        @click="viewButton(scope.row)"
                      >查看</el-button
                      >
                      <el-button
                        size="mini"
                        type="primary"
                        plain
                        :disabled="is_edit"
                        @click="setTaxRate(scope.row.id, scope.row.rate,scope.row.rate_type)"
                      >设置税率</el-button
                      >
                      <el-button
                        v-if="scope.row.bankPid=='alipaydirect'"
                        size="mini"
                        type="primary"
                        plain
                        :disabled="is_edit"
                        @click="alipayAuthFun(scope.row)"
                      >授权</el-button
                      >
                      <el-popover
                        v-if="(userPermissions.indexOf('merchant_Delete_Account') != -1) && (query.category != 'channel')"
                        :ref="'el-popover-'+scope.$index" placement="top" width="150">
                        <p>确定要删除记录吗？</p>
                        <div style="text-align: right; margin: 0;">
                          <el-button type="text" size="mini"
                            @click="$refs['el-popover-'+scope.$index].doClose()">取消</el-button>
                          <el-button v-if="(userPermissions.indexOf('merchant_Delete_Account') != -1) && (query.category != 'channel')" type="danger" size="mini" @click="deleteSubAccount(scope.row.id)">确定
                          </el-button>
                        </div>
                        <el-button slot="reference" type="danger" size="mini">删除</el-button>
                      </el-popover>
                    </span>
                  </template>
                </el-table-column>
              </ApeTable>
            </div>
            <div v-show="inSiderName == 'userInfo'">
              <el-row
                style="height: 36px; display: flex; flex-direction: row-reverse"
              >
                <el-button
                  :disabled="isAbleUserBtn"
                  size="medium"
                  type="primary"
                  @click="addUser"
                >添加用户
                </el-button
                >
              </el-row>
              <ApeTable
                ref="useApeTable"
                :data="userList"
                :columns="userColumns"
                :loading="userLoadingStaus"
                :pagingData="userPagingData"
                @switchPaging="userSwitchPaging"
                highlight-current-row
              >
                <el-table-column
                  width="160"
                  header_align="center"
                  align="center"
                  label="操作"
                >
                  <template slot-scope="scope">
                    <span>
                      <el-button
                        size="mini"
                        type="default"
                        :disabled="isAbleUserBtn"
                        @click="editButton(scope.row)"
                      >编辑</el-button
                      >
                      <span>
                        <el-popover
                          placement="top"
                          width="150"
                          v-model="scope.row.visible"
                        >
                          <p>确定要删除记录吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button
                              type="text"
                              size="mini"
                              @click="scope.row.visible = false"
                            >取消</el-button
                            >
                            <el-button
                              type="danger"
                              size="mini"
                              @click="deleteButton(scope.row.id)"
                            >确定</el-button
                            >
                          </div>
                          <el-button
                            slot="reference"
                            type="danger"
                            size="mini"
                            :disabled="isAbleUserBtn"
                          >移除</el-button
                          >
                        </el-popover>
                      </span>
                    </span>
                  </template>
                </el-table-column>
              </ApeTable>
            </div>
          </el-col>
        </el-row>
      </div>
    </PageHeaderLayout>

    <!-- 设置税率模态框 -->
    <ModalDialog
      :dialogData="dialogData"
      @dialogConfirm="handleConfirm"
      @dialogClose="dialogClose"
    >
      <template slot="content">
        <el-form
          :model="taxRateData"
          ref="taxRateForm"
          label-position="left"
          label-width="96px"
        >
          <el-form-item label="当前税率">
            <div>{{ taxRateData.rate }}</div>
          </el-form-item>
          <el-form-item label="设置税率" prop="taxRate">
            <el-input
              v-model="taxRateData.taxRate"
              maxlength="5"
              style="width: 200px"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
<!--         <el-form-item label='税率类型'>
           <el-radio v-model="radioType" label="1" :disabled="rateNum">外加</el-radio>
           <el-radio v-model="radioType" label="2" :disabled="rateNum">内扣</el-radio>
         </el-form-item> -->
        </el-form>
      </template>
    </ModalDialog>
    <ApeDrawer
      :drawerData="drawerData"
      @drawerClose="drawerClose"
      @drawerConfirm="drawerConfirm"
    >
      <template slot="ape-drawer">
        <el-form
          :model="userFormData"
          :rules="isAdd ? addUserRules : editUserRules"
          ref="userForm"
          label-position="right"
          label-width="96px"
        >
          <el-row>
            <el-col :span="22">
              <el-form-item label="手机号" prop="mobile">
                <el-input v-model="userFormData.mobile" @input="event_inputMobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="姓名" prop="fullname">
                <el-input v-model="userFormData.fullname"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="Email" prop="email">
                <el-input v-model="userFormData.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="密码" prop="password">
                <el-input v-model="userFormData.password">
                  <template slot="append">
                    <el-button
                      type="primary"
                      @click="randSecret"
                      icon="el-icon-refresh-right"
                      id="generate"
                    >
                      生成SECRET
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="this.$route.query.category != 'channel'">
            <el-col :span="22">
              <el-form-item label="权限" prop="user_type">
                <el-radio v-model="userFormData.user_type" :label="0"
                >操作人员
                </el-radio
                >
                <el-radio v-model="userFormData.user_type" :label="1"
                >审核人员
                </el-radio
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="用户类型" prop="type">
                <el-radio v-model="userFormData.type" :label="0"
                  >员工
                </el-radio>
                <el-radio v-model="userFormData.type" :label="1"
                  >管理者
                </el-radio>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </ApeDrawer>
    <!-- 短信模版模态框 -->
    <ModalDialog
      :dialogData="smsDialogData"
      @dialogConfirm="smsHandleConfirm"
      @dialogClose="smsDialogClose"
    >
      <template slot="content">
        <el-form :model="smsForm" ref="form" label-width="80px">
          <el-form-item label="模版">
            <el-radio-group v-model="smsForm.template_id" @change="selectRadio">
              <el-radio
                v-for="(item, index) in smsData"
                :key="index"
                :label="item.template_id"
              >{{ item.desc }}
              </el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="描述">
            <el-input
              v-model="smsForm.template_desc"
              placeholder="请输入描述信息"
            ></el-input>
          </el-form-item>
          <el-form-item label="平台名">
            <el-input
              v-model="smsForm.sms_alias_name"
              placeholder="请输入平台名"
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>

    <!-- 查看银行账户 -->
    <ModalDialog
      :dialogData="bankDialogData"
      :showButton="showButton"
      @dialogConfirm="bankHandleConfirm"
      @dialogClose="bankDialogClose"
    >
      <template slot="content">
        <el-form
          class="sub-account"
          :model="bankForm"
          ref="bankForm"
          label-position="left"
          label-width="90px"
        >
          <el-form-item label="打款账户:">{{
              bankForm.tradeAccount
            }}
					</el-form-item>
					<el-form-item label="打款开户行:">{{
              bankForm.tradeBank
            }}
					</el-form-item>
					<el-form-item label="打款户名:">{{
              bankForm.channelName
            }}
          </el-form-item>
          <el-form-item v-if="bankForm.new_account" label="Account:">{{
              bankForm.new_account
            }}
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>

    <!-- 生成银行账户 -->
    <el-dialog
      width="50%"
      :title="'生成银行账户'"
      :before-close="handleOuterClose"
      :visible.sync="outerVisible"
      class="account-wrapper"
    >
      <el-form
        :model="accountForm"
        ref="accountForm"
        :rules="bankRules"
        label-width="120px"
        label-position="left"
      >
        <!--TODO:-->
        <el-form-item label="服务公司" prop="settlementId">
          <el-select
            filterable
            v-model="accountForm.settlementId"
            placeholder="请选择服务公司"
            @change="settlementChange"
            class="settlement-select"
          >
            <el-option
              v-for="item in settlementList"
              :key="item.channel_account"
              :label="item.channel_name"
              :value="item.channel_account"
            ></el-option>
          </el-select>
        </el-form-item>
        <div v-if="false">
            <el-form-item label="access_token" class="set" prop="jiehaohuo_access_token">
              <el-input v-model="accountForm.jiehaohuo_access_token"></el-input>
            </el-form-item>
        </div>
        
        <div v-if="false">
            <el-form-item label="refresh_token" class="set" prop="jiehaohuo_refresh_token">
              <el-input v-model="accountForm.jiehaohuo_refresh_token"></el-input>
            </el-form-item>
        </div>
        <div v-if="false">
        <el-form-item label="时间" class="set" prop="jiehaohuo_token_time">
        <el-date-picker
        v-model="accountForm.jiehaohuo_token_time"
        type="datetime"
        placeholder="请选择时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        />
        </el-form-item>
        </div>
        <div v-if="showMerchantNo">
            <el-form-item :label="channelAccount_type == 'wrp' ? '商户号(appid)' : '商户号'" class="set" prop="merchant_no">
              <el-input v-model="accountForm.merchant_no"></el-input>
            </el-form-item>
        </div>

        <div v-if="showPrincipalId">
          <el-form-item label="地区ID" class="set" prop="principal_id">
            <el-input v-model="accountForm.principal_id"></el-input>
          </el-form-item>
        </div>

        <div v-if="showAccount">
            <el-form-item label="账户号" class="set" prop="account">
              <el-input v-model="accountForm.account"></el-input>
            </el-form-item>
        </div>
        
        <div v-if="showApiKey">
            <el-form-item label="税优地ApiKey" class="set" prop="sy_des_key">
              <el-input v-model="accountForm.sy_des_key"></el-input>
            </el-form-item>
        </div>

        <div v-if="showPaidaxinMerchantNo">
            <el-form-item label="用户名" class="set" prop="merchant_no" 
            :rules="[{ required: true, message:'请输入用户名', trigger: 'blur'}]">
              <el-input v-model="accountForm.merchant_no"></el-input>
            </el-form-item>
        </div>

        <div v-if="showPaidaxinApiKey">
            <el-form-item label="密码" class="set" prop="sy_des_key"
            :rules="[{ required: true, message:'请输入密码', trigger: 'blur'}]">
              <el-input v-model="accountForm.sy_des_key"></el-input>
            </el-form-item>
        </div>

        <div v-if="showTaskId">
            <el-form-item label="任务ID" class="set" prop="task_id">
              <el-input v-model="accountForm.task_id"></el-input>
            </el-form-item>
        </div>

        <div class="bank-wrapper" v-if="showBankExtraInfo">
          <el-form-item label="来款银行" class="set" prop="in_bank_code">
            <el-select v-model="accountForm.in_bank_code" clearable filterable placeholder="请选择" style="width:400px">
              <el-option
                v-for="item in this.bankCodeList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="户名" class="set" prop="in_bank_name">
            <el-input v-model="accountForm.in_bank_name"></el-input>
          </el-form-item>
          <div class="form-alert bank">（微信必填，其他选填）</div>
          <el-form-item label="来款银行帐号" class="set" prop="in_bank_no">
            <el-input v-model="accountForm.in_bank_no"></el-input>
          </el-form-item>
          <div class="form-alert bank">（微信必填，其他选填）</div>
          <el-form-item label="微信appid" class="set" prop="wechat_app_id">
            <el-input v-model="accountForm.wechat_app_id"></el-input>
          </el-form-item>

          <!-- <div class="form-alert bank">（网商开户可选填，盛京银行开户必填）</div> -->
        </div>
        <div v-if="showOpenAccount">
        <el-form-item
          label="支付宝PID："
          prop="alipay_user_id"
        >
          <el-input
            v-model="accountForm.alipay_user_id"
            placeholder="请输入正确的支付宝PID"
            @input="change()"
            class="settlement-select"
          />
        </el-form-item>
          <!-- 新增字段：转账场景描述 -->
          <el-form-item label="转账场景描述" prop="transfer_scene_describe">
            <el-input
              v-model="accountForm.transfer_scene_describe"
              type="textarea"
              :rows="5"
              placeholder="(甲方公司名称)作为甲方委托(乙方公司名称)作为税地下发，现申请账户用于记账本充值，后调拨给(乙方公司名称)。(甲方公司名称)主要从事XX业务，需要给XX人群代发资金(举例:如经营XX交友APP，需要给主播下发资金;经营XX信息平台，发布任务召集完成，需要给承接任务人员代发;甲方在某地开设大型服装工厂，有员工XX人，需要委托乙方公司代发)。"
              class="settlement-textarea"
            />
          </el-form-item>
          <!-- 新增字段：转账场景图片 -->
          <el-form-item label="转账场景图片" prop="transfer_scene_pic">
            <div class="transfer-wrapper">
              <upload-files
                @remove_file="handleRemoveAccountFile"
                @return_url="handUploadAccountFile"
                @before_upload="beforeUpload"
                :existFile="accountForm.transfer_scene_pic"
                :title="'转账场景图片'"
                :multiple="'true'"
                :multiSelection="true"
                :dir="'bill'"
                :selectfiles="'transferScenePicImport'"
                :postfiles="'transferScenePic'"
                :ossfile="'ossTransferScenePicFile'"
                ref="transferScenePic"
                :fileUrl="dataTransferScenePic"
                :max_width="1000"
                :max_size="5"
              />
              <div class="desc">
                <div>支持格式：jpg/png/svg/gif，单个文件不能超过5M</div>
                <div>(B端系统首页截图，数据空的也可以)</div>
              </div>
            </div>
          </el-form-item>
          <!-- 新增字段：协议文件 -->
          <el-form-item label="用工企业和税源地的协议文件" prop="transfer_scene_file">
            <div class="transfer-wrapper">
              <upload-files
                @remove_file="handleRemoveAccountFile"
                @return_url="handUploadAccountFile"
                @before_upload="beforeUpload"
                :existFile="accountForm.transfer_scene_file"
                :title="'协议文件'"
                :multiple="'true'"
                :multiSelection="true"
                :dir="'bill'"
                :selectfiles="'transferSceneFileImport'"
                :postfiles="'transferSceneFile'"
                :ossfile="'ossTransferSceneFile'"
                ref="transferSceneFile"
                :fileUrl="dataTransferSceneFile"
                :max_width="1000"
                :max_size="5"
              />
              <div class="desc">
                <div>支持格式：jpg/png/svg/gif，单个文件不能超过5M</div>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            v-if="alipay_application_status"
            label="状态"
            prop="alipay_application_status"
          >
            <el-tag :type="getTagType(alipay_application_status)">
              {{ alipayApplicationStatusMap[alipay_application_status] }}
            </el-tag>
          </el-form-item>
        </div>
      </el-form>
      <el-dialog
        width="35%"
        :close-on-click-modal="false"
        title="系统提示"
        :visible.sync="innerVisible"
        :before-close="handleInnerClose"
        append-to-body
      >
        <div>
          <div class="accountTips">
            <el-alert
              :title="this.isColorChange ? '抱歉银行账户创建失败' : '银行账户创建成功'
              " :type="this.isColorChange ? 'error' : 'success'" :closable="false" show-icon>
						</el-alert>
					</div>
					<el-form class="sub-account" :model="bankForm">
						<el-form-item label="打款账户:">{{
                bankForm.tradeAccount
              }}
						</el-form-item>
						<el-form-item label="打款开户行:">{{
                bankForm.tradeBank
              }}
						</el-form-item>
						<el-form-item label="打款户名:">{{
                bankForm.channelName
              }}
						</el-form-item>
						<el-form-item label="子账号ID:">{{ bankForm.uid }}</el-form-item>
            <el-form-item v-if="bankForm.new_account" label="Account:">{{
              bankForm.new_account
            }}
          </el-form-item>
					</el-form>
				</div>
				<div></div>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="checkInner" size="medium">关闭
					</el-button>
				</div>
			</el-dialog>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelOuter" size="medium">取 消</el-button>
				<el-button
          v-if="showOpenAccount && alipay_application_status!=2"
          type="primary"
          @click="checkOuter"
          size="medium"
          :disabled="this.isShowOuterCheckBtn || alipay_application_status==1 || alipay_application_status==2"
          >{{ alipay_application_status ? '重新提交' : '提交' }}
        </el-button>
        <el-button
          v-else
          type="primary"
          @click="checkOuter"
          size="medium"
          :disabled="this.isShowOuterCheckBtn"
          >生成银行账户
        </el-button>
			</div>
		</el-dialog>

		<el-dialog title="申请开户" :visible.sync="openAccountDialogVisible" width="30%"
			:before-close="openAccountHandleClose">
			<div class="qr-code-wrapper" v-if="sign_url!==''">
				<el-button class="copyBtn" size="medium" @click="copyText()">一键复制
				</el-button>
				<div class="link-title">
					请点击以下链接到手机支付宝扫码进行签约，此链接100秒有效期
				</div>
				<a ref="copyText" target="_blank" :href="sign_url">{{
            this.sign_url
          }}</a
        >
      </div>
      <div class="link-title" v-else>
        签约已完成
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="sign_url!==''" class="el-icon-refresh-left" @click="Recapture"
        >重新获取{{ this.time ? `(${this.time})` : "" }}</el-button
        >
        <el-button type="primary" @click="finishSign">已完成签约</el-button>
      </span>
    </el-dialog>
    
    <AlipayAuth
      :data="alipayAuth"
      :isVisible="isVisibleAuth"
      @emitCheckAuth="emitCheckAuth"
      @emitAuthDialogClose="emitAuthDialogClose"
    />
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import UploadFile from "@/components/UploadFile";
import inSiderMenu from "@/layouts/inSiderMenu";
import ApeTable from "@/components/ApeTable";
import AlipayAuth from "@/components/AlipayAuth";
import ModalDialog from "@/components/ModalDialog";
import ApeDrawer from "@/components/ApeDrawer";
import UploadFiles from "@/components/UploadFiles";
import { debounce } from 'lodash'
// import { delete } from 'vue/types/umd';
import {
		mapGetters
	} from "vuex";
export default {
  components: {
    PageHeaderLayout,
    UploadFile,
    inSiderMenu,
    ApeTable,
    ModalDialog,
    ApeDrawer,
    AlipayAuth,
	UploadFiles
  },
  watch: {
    "taxRateData.taxRate": function (val) {
      if (val) {
        this.dialogData.loading = false;
      } else {
        this.dialogData.loading = true;
      }
    },
    acct_type: function (v) {
      if (v) {
        this.acct_typeList = true;
      } else {
        this.acct_typeList = false;
      }
    },
    "accountForm.settlementId": function (v) {
      if (v) {
        this.isShowOuterCheckBtn = false;
      } else {
        this.isShowOuterCheckBtn = true;
      }
    },
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  data() {
    return {
      channelAccount_type: '',
      // 0：待提交 1：审核中 2：审核通过 3：审核未通过 4：已废弃 5：已撤销
      alipay_application_status: null,
      alipayApplicationStatusMap: {
        0: "待提交",
        1: "审核中",
        2: "审核通过",
        3: "审核未通过",
        4: "已废弃",
        5: "已撤销",
      },
      query:{},
        alipayAuth:{},
        isVisibleAuth:false,
      showApiKey:false,
      showPaidaxinMerchantNo:false,
      showPaidaxinApiKey:false,
      showTaskId:false,
      showSL: false,
      radioType: "1",
      Taxratedatas: [],
      // 梯度税率数据
      gradsdata: [
        {
          money: '',
          rate: '',
        },
        {
          money: '',
          rate: '',
        },
      ],
      gradstaxRate: {
        rate: "",
      },
      radio: "1",
      isCopy: false,
      sign_url: "",
      // 选取的税率类型
      taxRateType: 1,
      showOpenAccount: false,
      openAccountDialogVisible: false,
      isAbleBankBtn: true,
      isAbleUserBtn: true,
      enumList: [],
      rateNum: true,
      signTypeList: [
        {
          value: "def",
          label: "默认",
        },
        {
          value: "esign",
          label: "e签宝",
        },
        // {
        //   value: 'fsign',
        //   label: '放心签'
        // }
      ],
      isladder: false,
      showBankExtraInfo: false,
      showMerchantNo:false,
      showAccount: false,
      showPrincipalId: false,
      companyId: "",
      companyName: "",
      dataContractUrl: "",
      dataRiskUrl: [],
      dataTransferScenePic: "",
      dataTransferSceneFile: "",
      userId: "",
      outerVisible: false, //控制外层弹窗显示/隐藏
      acct_typeList: "", //是否生成服务费账户
      acct_type: 0,
      isColorChange: false,
      isShowOuterCheckBtn: true, //外层弹窗按钮是否可用
      innerVisible: false, //控制内层弹窗显示/隐藏
      bankCodeList: [],
      accountForm: {
        merchant_no:'', //商户号
        principal_id:'', //地区ID
        account: '', //账户号
        sy_des_key:'', // 税优地ApiKey
        task_id:'',//任务ID
        settlementId: "",
        in_bank_code: "",
        in_bank_no: "",
        acct_typeList: "",
        in_bank_name: "",
        wechat_app_id:"",
		jiehaohuo_access_token:'',
		jiehaohuo_refresh_token:'',
		jiehaohuo_token_time:'',
        transfer_scene_describe: '',
        transfer_scene_pic: '',
        transfer_scene_file: '',
        alipay_user_id: ''
      },
      bankForm: {
        tradeAccount: "",
        tradeBank: "",
        channelName: "",
        uid: "",
      },
      bankRules: {
        settlementId: [
          {required: true, message: "请选择服务公司", trigger: "blur"},
        ],
        alipay_user_id: [
          {required: true, message: "请输入支付宝PID", trigger: "blur"},
        ],
        in_bank_code: [
          {required: true, message: "请选择来款银行", trigger: "blur"},
        ],
        in_bank_no: [
          {required: true, message: "请输入来款银行帐号", trigger: "blur"},
        ],
        wechat_app_id:[
         {required: true, message: "请输入微信appid", trigger: "blur"},
        ],
        merchant_no: [
          { required: true, message: "请输入商户号", trigger: "blur" },
        ],
        principal_id:[
          { required: true, message: "请输入地区ID", trigger: "blur" },
        ],
        account: [
          { required: true, message: "请输入账户号", trigger: "blur" },
        ],
        sy_des_key: [
          { required: true, message: "请输入税优地ApiKey", trigger: "blur" },
        ],
        task_id: [
          { required: true, message: "请输入任务ID", trigger: "blur" },
        ],
		jiehaohuo_access_token: [
			{ required: true, message: "请输入access_token", trigger: "blur" },
		],
		jiehaohuo_refresh_token: [
			{ required: true, message: "请输入refresh_token", trigger: "blur" },
		],
		jiehaohuo_token_time: [
			{ required: true, message: "请选择时间", trigger: "change" },
			{ required: true, message: "请选择时间", trigger: "blur" },
		],
        transfer_scene_describe: [
          { required: true, message: "请输入转账场景描述", trigger: "blur" },
        ],
        transfer_scene_pic: [
          { required: true, message: "请上传转账场景图片", trigger: "change" },
        ],
        transfer_scene_file: [
          { required: true, message: "请上传协议文件", trigger: "change" },
        ],
      },
      bankDialogData: {
        visible: false,
        title: "",
        width: "35%",
        loading: false,
        modal: false,
      },
      showButton: ["cancel"],
      smsForm: {
        template_id: "",
        template_desc: "",
        sms_alias_name: "",
      },
      smsDialogData: {
        visible: false,
        title: "短信模版",
        width: "45%",
        loading: true,
        modal: false,
      },
      smsData: "",
      // 搜索条件
      searchCondition: {},
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: "正在加载中……",
        title: "权限绑定",
        width_height: "480px",
      },
      // 表单结构
      userFormData: {
        password: "",
      },
      isAdd: true,
      // 表单验证
      addUserRules: {
        mobile: [
          {required: true, message: "输入手机号", trigger: "blur"},
          {min: 11,max:11, message: "请输入11位手机号"},
        ],
        fullname: [{required: true, message: "输入姓名", trigger: "blur"}],
        password: [{required: true, message: "请输入密码", trigger: "blur"}],
        user_type: [{required: true, message: "请选择权限", trigger: "blur"}],
      },
      editUserRules: {
        mobile: [
          {required: true, message: "输入手机号", trigger: "blur"},
          {min: 11,max:11, message: "请输入11位手机号"},
        ],
        password:[
          {
            min:6,message:"请输入6位以上密码"
          },
          {
            pattern: /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{6,}$/ ,  message: '请输入包含数字、字母、特殊字符正确格式的密码', trigger: 'blur' 
          }
        ],
        fullname: [{required: true, message: "输入姓名", trigger: "blur"}],
        user_type: [{required: true, message: "请选择权限", trigger: "blur"}],
      },
      // 用户绑定角色
      rolesList: [
        {
          display_name: "操作人员",
          id: 0,
        },
        {
          display_name: "审核人员",
          id: 1,
        },
      ],
      // 用户绑定公司
      companyList: [],
      // 用户绑定服务公司
      settlementList: [],
      taxRateData: {
        taxRate: "",
        rate: "",
      },
      dialogData: {
        visible: false,
        title: "",
        width: "25%",
        loading: true,
        modal: false,
      },
      loadingStaus: false,
      userLoadingStaus: false,
      //用户分页信息
      userPagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      //银行账户分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      //银行账户信息
      list: [],
      userList: [],
      columns: [
        {
          title: "子账号id",
          value: "uid",
          header_align: "center",
          align: "center",
        },
        {
          title: "户名",
          value: "company_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "账户",
          value: "account",
          header_align: "center",
          align: "center",
        },
        {
          title: "服务公司",
          value: "channel_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "税率",
          value: "rate",
          header_align: "center",
          align: "center",
        },
        {
          title: "余额",
          value: "balance_money",
          header_align: "center",
          align: "center",
        },
      ],
      userColumns: [
        {
          title: "ID",
          value: "id",
          header_align: "center",
          align: "center",
        },
        {
          title: "手机号",
          value: "mobile",
          header_align: "center",
          align: "center",
        },
        {
          title: "权限",
          value: "alias_user_type",
          header_align: "center",
          align: "center",
        },
        {
          title: "用户类型",
          value: "alias_type",
          header_align: "center",
          align: "center",
        },
        {
          title: "状态",
          header_align: "center",
          align: "center",
          value: [
            {label: "创建时间：", value: "create_time"},
            {label: "最后登录时间：", value: "last_login_at"},
            {label: "用户IP：", value: "last_ip"},
            {label: "成功次数：", value: "login_times"},
          ],
        },
      ],
      display_name: "商户基本信息",
      inSiderName: "basicInfo",
      form: {
      category_list:[]
      },
      categoryList:[],
      form_category_list:[],
      rules: {
        name: [{required: true, message: "请输入企业名称", trigger: "blur"},{min: 4, message: "不低于四位字符"},],
        company_phone: [
          {required: true, message: "请输入企业电话", trigger: "blur"},
          {min: 6, message: "不能低于6位"}
        ],
        taxpayer: [
          {required: true, message: "请输入企业税号", trigger: "blur"},
        ],
        bank: [{required: true, message: "请输入开户行", trigger: "blur"}],
        address: [
          {required: true, message: "请输入企业地址", trigger: "blur"},
        ],
        account: [
          {required: true, message: "请输入银行账户", trigger: "blur"},
          {min: 9, message: "不能低于9位"}
        ],
        category:[
        { required: true, message: "请选择签约服务类型", trigger: "change" }
        ]
      },
      channelRules: {
        name: [{required: true, message: "请输入企业名称", trigger: "blur"}],
        company_phone: [
          {required: true, message: "请输入企业电话", trigger: "blur"},
        ],
      },
      is_edit: false,
      is_repeat: true,
      time: 100,
      isRepeat: false,
	is_jiehaohuo:false,
    };
  },
  methods: {
	event_inputMobile(){
		this.userFormData.mobile = this.userFormData.mobile.replace(/[^\d]/g,'')
	},
    //开票类目列表
    async getInvoiceCategoryList() {
      let result = await this.$api.getInvoiceCategoryList();
      if (result) {
        this.categoryList = result;
      }
    },
    // 删除商户
    async deleteSubAccount(id) {
      await this.$api.deleteSubAccount(id)
      if (this.$route.query.id) {
        this.subAccount(this.$route.query.id);
      } else {
        this.subAccount(this.companyId);
      }
    },
      emitAuthDialogClose() {
        this.isVisibleAuth = false;
      },
      emitCheckAuth(val) {
        this.isVisibleAuth = val;
      },
      // 支付宝授权
      alipayAuthFun(e) {
        console.log(e,'选择的内容')
        this.isVisibleAuth = true;
        this.alipayAuth.channel_account = e.channel_account;
        this.alipayAuth.company_id = this.$route.query.id;
      },
      selectChange() {
        console.log(21312321);
        this.$forceUpdate();
      },
    formatCompany(){
       // this.form.name = this.form.name.replace(/[^\u4e00-\u9fa5]/g,'')
    },
/*    //增加税率项
    addSuiItem() {
      let obj = {
        money: '',
        rate: ''
      }
      this.gradsdata.push(obj)
    },
    //删除税率项
    plusSuiItem(e) {
      this.gradsdata.splice(e, 1)
    },*/

    // 固定税率
    fixation() {
      this.isladder = false;
      this.taxRateType = 1;
      // if ((this.taxRateType = 1)) {
      //   this.Taxratedata = [];
      // }

    },
    // 梯度税率
    grads() {
      this.isladder = true;
      this.taxRateType = 2;
    },
    //一键复制
    copyText() {
      var that = this;
      if (!that.isCopy) {
        var clipboard = new this.clipboard(".copyBtn", {
          target: function () {
            return that.$refs.copyText;
          },
        });
      }
      clipboard.on("success", function () {
        that.$message.success("复制成功");
      });
      clipboard.on("error", function () {
        that.$message.success("复制失败");
      });
      that.isCopy = true;
    },
    // 倒计时方法100秒
    countDown(time) {
      if (time === 0) {
        this.isRepeat = true;
        return;
      } else {
        time--;
        this.isRepeat = false;
      }
      setTimeout(() => {
        this.countDown(time);
      }, 1000);
      this.time = time;
    },
    //重新获取
    Recapture() {
      if (this.isRepeat) {
        this.generateBankAccount();
      }
    },
    //已完成签约
    async finishSign() {
      if (this.sign_url === '') {
        this.openAccountDialogVisible = false
        this.$message.success("已成功签约");
        return false
      }
      var signId;
      if (this.$route.query.id) {
        signId = this.$route.query.id;
      } else {
        signId = this.companyId;
      }
      let args = {
        channel_account: this.accountForm.settlementId,
      };
      let result = await this.$api.alipayAccount(signId, args);
      if (result) {
        this.innerVisible = true;
        this.outerVisible = false;
        this.bankForm.tradeAccount = result.trade_account;
        this.bankForm.tradeBank = result.trade_bank;
        this.bankForm.channelName = result.channel_name;
        this.bankForm.new_account = result.new_account;
        this.bankForm.uid = result.uid;
        if (this.$route.query.id) {
          this.subAccount(this.$route.query.id);
        } else {
          this.subAccount(this.companyId);
        }
      }
    },
    //关闭申请开户模态框
    openAccountHandleClose() {
      this.openAccountDialogVisible = false;
      this.acct_type = 0;
      this.showOpenAccount = false;
      this.$refs["accountForm"].resetFields();
    },
    //支持批量人才导入开关
    openImport() {
      if (this.form.is_import == 1) {
        this.form.is_import = 1;
      }
      if (this.form.is_import == 0) {
        this.form.is_import = 2;
      }
    },
    //角色列表
    async getRolesList() {
      let result = await this.$api.getRolesList();
      if (result) {
        this.rolesList = result;
      }
    },
    //创建银行账户
    async createAlipaySubmission(id, data) {
      try {
        let result = await this.$api.createAlipaySubmission({...data,company_id:id});
        if (result) {
          this.acct_type = 0;
          this.outerVisible = false;
          this.innerVisible = false;
          this.handleInnerClose();
          this.$message.success("提交成功");
          if (this.$route.query.id) {
            this.subAccount(this.$route.query.id);
          } else {
            this.subAccount(this.companyId);
          }
        }
      } catch (err) {
        console.log("err is ->", err);
        this.openAccountDialogVisible = false;
      }
    },
    //创建银行账户
    async createAccount(id, data) {
      try {
        let result = await this.$api.createAccount(id, data);
        if (result) {
          this.acct_type = 0;
          this.bankForm.tradeBank = result.trade_bank;
          this.bankForm.tradeAccount = result.trade_account;
          this.bankForm.channelName = result.channel_name;
          this.bankForm.new_account = result.new_account;
          this.bankForm.uid = result.uid;
          this.sign_url = result.sign_url;
          if (this.showOpenAccount && this.sign_url) {
            this.openAccountDialogVisible = true;
            this.outerVisible = false;
          } else {
            this.outerVisible = false;
            this.innerVisible = true;
          }
          if (this.sign_url) {
            this.countDown(100);
          }
          this.$message.success("生成开户链接成功");
          if (this.$route.query.id) {
            this.subAccount(this.$route.query.id);
          } else {
            this.subAccount(this.companyId);
          }
        }
      } catch (err) {
        console.log("err is ->", err);
        this.openAccountDialogVisible = false;
      }
    },

    //商户管理-渠道详情
    async channelView(id) {
      let result = await this.$api.channelView(id);

      if (result) {
        if (result.contract_file_url) {
          this.dataContractUrl = result.contract_file_url;
        }
        this.form = result;
        this.radio = this.form.type;
        this.gradsdata = this.form.key;
        if (this.radio == '2') {
          this.isladder = true
        }
        if (result.is_edit) {
          this.is_edit = false;
          this.isAbleUserBtn = false;
        } else {
          this.is_edit = true;
          this.isAbleUserBtn = true;
        }
      }
    },

    //商户管理-渠道列表
    async getSettlementCategoryList() {
      let result = await this.$api.getSettlementCategoryList();
      if (result) {
        this.settlementList = result;
      }
    },

    //生成银行账户服务公司
    async tenantCategoryList() {
      let result = await this.$api.tenantCategoryList();
      // result.filter((item) => {
      //   if (item.yl_bank === "ws") {
      //     item.channel_name += "(网商银行)";
      //   } else if (item.yl_bank === "alipay") {
      //     item.channel_name += "(支付宝)";
      //   } else if (item.yl_bank === "sj") {
      //     item.channel_name += "(盛京银行)";
      //   }
      //   return item;
      // });
      if (result) {
        this.settlementList = result;
      }
    },

    //获取全部公司
    async getCompanyCategoryList() {
      let result = await this.$api.getCompanyCategoryList();
      if (result) {
        this.companyList = result.data;
      }
    },
    // 返回 el-tag 的类型
    getTagType(status) {
      switch (Number(status)) {
        case 0:
          return "info";
        case 1:
          return "warning";
        case 2:
          return "success";
        case 3:
          return "danger";
        case 4:
          return "info";
        case 5:
          return "warning";
        default:
          return "info";
      }
    },
    async alipaySubmissionInfo() {
      let param = {
        company_id: this.$route.query.id || this.companyId,
        channel_account: this.accountForm.settlementId,
      };
      let result = await this.$api.alipaySubmissionInfo(param);
      this.accountForm = JSON.parse(JSON.stringify(this.accountForm));
      this.alipay_application_status = result.alipay_application_status || null;
      this.accountForm.alipay_user_id = result.alipay_user_id || "";
      this.accountForm.transfer_scene_describe = result.transfer_scene_describe || "";
      this.dataTransferScenePic = result.transfer_scene_pic || "";
      this.accountForm.transfer_scene_pic = result.transfer_scene_pic || "";
      this.accountForm.transfer_scene_file = result.transfer_scene_file || "";
      this.dataTransferSceneFile = result.transfer_scene_file || "";
      console.log(result, "alipaySubmissionInfo");
    },
    // 银行账户列表
    async subAccount(id) {
      console.log("----------", id);
      let result = await this.$api.subAccount(id);
      if (result) {
        this.list = result;
      }
    },
    //服务公司选择
    async settlementChange(v) {
      console.log(v, "v");
		
      if (v) {
        let info = {};
        let selectedSettlement = this.settlementList.find((item) => {
          return item.channel_account === v;
        });
        let contrastResult = this.list.filter((item) => {
          return item.channel_account === selectedSettlement.channel_account;
        });
        console.log(contrastResult);
        if (contrastResult.length > 0) {
          this.bankForm.tradeAccount = contrastResult[0].trade_account;
          this.bankForm.tradeBank = contrastResult[0].trade_bank;
          this.bankForm.channelName = contrastResult[0].channel_name;
          this.bankForm.new_account = contrastResult[0].new_account;
          this.bankForm.uid = contrastResult[0].uid;
          this.is_repeat = false;
        } else {
          this.is_repeat = true;
        }
        let channelAccountTypeList = {
          sy: ['sycard', 'syalipay', 'sywechat'], // 税优地
          lingxin:['lingxincard','lingxinalipay','lingxinwechat','lingxin'], //领薪
          huifu:['huifucard','huifualipay','huifuwechat','huifu'], //汇付
          alipay:['xlwalipay','xlwalipaydirect'], //支付宝及xlwalipay
          jingling:['jinglingpay'],
          paidaxin:['paidaxinalipay','paidaxinwechat','paidaxincard'], //派达薪
          wrp:['wrp','wrppay'],
        }
        this.channelAccount_type = ''
        this.settlementList.forEach((item) => {
          info[item.channel_account] = item.yl_bank;
          for(let key in channelAccountTypeList){
            if(channelAccountTypeList[key].length){
              if(channelAccountTypeList[key].includes(item.yl_bank)){
                info[item.channel_account] = key
                this.channelAccount_type = key
              }
            }
          }
         
        });
        // 初始化部分变量
        this.resetValue();
        this.accountForm.alipay_transit_type = "";
        this.accountForm.principal_id = "";
        this.accountForm.in_bank_code = "";
        this.accountForm.in_bank_no = "";
        this.accountForm.in_bank_name = "";
        this.accountForm.transfer_scene_describe = "";
        this.accountForm.transfer_scene_pic = "";
        this.accountForm.transfer_scene_file = "";
        this.dataTransferScenePic = "";
        this.dataTransferSceneFile = "";
        this.bankRules.in_bank_name = [{ required: false, message: "请输入户名", trigger: "blur" }];
        switch (info[v]) {
          case "ws":

            break;
          case "alipay":
            this.showOpenAccount = true;
            this.accountForm.alipay_transit_type = "0";
            this.alipaySubmissionInfo();
            break;
          case "wechat":
            this.showBankExtraInfo = true;
            break;
          case "lingxin":  //增加商户号输入
              this.showMerchantNo = true;
              break;
          case "wrp":  //增加商户号输入
              this.showMerchantNo = true;
              break;
          case "huifu":  //增加商户号及账号输入
              this.showMerchantNo = true;
              this.showAccount = true;
              break;
          case "jingling"://增加商户号输入
              this.showMerchantNo = true;
              this.showPrincipalId = true;
              break;
          case "sy":  //增加商户号输入
              this.showMerchantNo = true;
              this.showApiKey = true;
              break;
          case "paidaxin":  //派达薪通道
              this.showPaidaxinMerchantNo = true;
              this.showPaidaxinApiKey = true;
              this.showTaskId = true;
              break;
          case "umfpay":
            // 注释掉  暂时不需要填写
            // this.showBankExtraInfo = true;
            // this.bankRules.in_bank_name = [{ required: true, message: "请输入户名", trigger: "blur" }];
            break;
          default:
            break;
        }
        this.accountForm.settlementId = v;
        this.getBankCode();
		if(v){
			const account_item=this.settlementList.find(item=>{
				return item.channel_account===v
			})
			if(account_item.is_jiehaohuo===1){
				this.is_jiehaohuo=true
				return 
			}else{this.is_jiehaohuo=false
			}
		}else{
			this.is_jiehaohuo=false
			return
		}
      }
    },
    //是否生成服务费账户单选按钮
    changeAcctType(e) {
      if (e) {
        this.acct_type = 1;
      } else {
        this.acct_type = 0;
      }
    },
    change() {
      this.$forceUpdate();
    },
    /*取消外层弹窗*/
    cancelOuter() {
      this.outerVisible = false;
      this.acct_type = 0;
      this.showBankExtraInfo = false;
      this.showMerchantNo = false;
      this.showPrincipalId = false;
      this.showApiKey = false;
      this.showOpenAccount = false;
      this.$refs["accountForm"].resetFields();
    },
    // 生成子账号表单
    async sonAccountForm() {
      this.settlementList.forEach((item) => {
        if (item.id == this.accountForm.settlementId) {
          this.accountName = item.name;
        }
      });
      let {settlementId, in_bank_code, in_bank_no,merchant_no,principal_id, account,sy_des_key,task_id} = this.accountForm;
      let result = await this.$api.createSubAccount(
        this.company_id,
        this.company_name,
        settlementId,
        this.acct_type,
        in_bank_code,
        in_bank_no,
        principal_id,
        sy_des_key = sy_des_key ? sy_des_key.trim():'',
        merchant_no = merchant_no ? merchant_no.trim():'',
        task_id = task_id ? task_id.trim():'',
        account = account ? account.trim():''
      );
      if (result) {
        this.bankForm.subAccountID = result.uid;
        this.bankForm.account = result.account;
        this.isColorChange = false;
      } else {
        this.isColorChange = true;
      }
    },

    //生成银行账户
    generateBankAccount() {
      var accountId = "",
        alipay_user_id = {alipay_user_id: this.accountForm.alipay_user_id},
        accountArgs = {
          company_name: this.companyName,
          channel_account: this.accountForm.settlementId,
          acct_type: this.acct_type,
          in_bank_code: this.accountForm.in_bank_code,
          in_bank_no: this.accountForm.in_bank_no,
          principal_id:this.accountForm.principal_id,
          merchant_no:this.accountForm.merchant_no ? this.accountForm.merchant_no.trim() : '',
          account:this.accountForm.account ? this.accountForm.account.trim() : '',
          sy_des_key:this.accountForm.sy_des_key ? this.accountForm.sy_des_key.trim() : '',
          task_id:this.accountForm.task_id ? this.accountForm.task_id.trim() : '',
          in_bank_name: this.accountForm.in_bank_name,
          wechat_app_id:this.accountForm.wechat_app_id,
          transfer_scene_describe: this.accountForm.transfer_scene_describe || '',
          transfer_scene_pic: this.accountForm.transfer_scene_pic || '',
          transfer_scene_file: this.accountForm.transfer_scene_file || '',
        };
		//接好活
		if(this.is_jiehaohuo){
			accountArgs.jiehaohuo_access_token=1
			accountArgs.jiehaohuo_refresh_token=''
			accountArgs.jiehaohuo_token_time=''
			console.log(accountArgs,'console.log(accountArgs)')
		}
      if (this.$route.query.id) {
        accountId = this.$route.query.id;
      } else {
        accountId = this.companyId;
      }
      console.log("this.showOpenAccount----------", this.showOpenAccount);
      if (this.showOpenAccount) {
        // eslint-disable-next-line no-debugger
        Object.assign(accountArgs, alipay_user_id);
        if (this.is_repeat) {
          console.log("绑定税源地");
          if(this.alipay_application_status!=2){
            this.createAlipaySubmission(accountId, accountArgs);
            return
          }
          // eslint-disable-next-line no-debugger
          this.createAccount(accountId, accountArgs);
        } else {
          this.outerVisible = false;
          this.innerVisible = true;
          // eslint-disable-next-line no-debugger
          this.acct_type = 0;
        }
      } else {
        console.log("this.is_repeat------", this.is_repeat);
        if (this.is_repeat) {
          this.createAccount(accountId, accountArgs);
        } else {
          this.outerVisible = false;
          this.innerVisible = true;
          this.acct_type = 0;
        }
      }
    },
    /*确定外层弹窗*/
    checkOuter:debounce(function(){
		this.$refs["accountForm"].validate((valid) => {
		if (valid) {
		this.generateBankAccount();
		}
		});
	},2000,{leading:true,trailing:false}),
    // 确定内层弹框
    checkInner() {
      this.innerVisible = false;
      this.openAccountDialogVisible = false;
      this.resetValue();
      this.$refs["accountForm"].resetFields();
    },
    resetValue(){
		this.is_jiehaohuo = false;
      this.showMerchantNo = false;//商户号
      this.showPrincipalId = false;
      this.showAccount = false; //账号
      this.showOpenAccount = false;
      this.showApiKey = false;
      this.showPaidaxinMerchantNo = false;
      this.showPaidaxinApiKey = false;
      this.showTaskId = false;
      this.showBankExtraInfo = false;
    },
    /*点击外层弹框小×*/
    handleOuterClose() {
      this.outerVisible = false;
      this.acct_type = 0;
      this.accountForm.principal_id = '';
      this.accountForm.merchant_no = '';
      this.accountForm.account = '';
      this.accountForm.sy_des_key = '';
      this.accountForm.task_id = '';
      this.accountForm.transfer_scene_describe = '';
      this.accountForm.transfer_scene_pic = '';
      this.accountForm.transfer_scene_file = '';
      this.dataTransferScenePic = '';
      this.dataTransferSceneFile = '';
      this.resetValue();
      this.$refs["accountForm"].resetFields();
    },
    //点击内层弹框小×
    handleInnerClose() {
      this.outerVisible = false;
      this.innerVisible = false;
      this.accountForm = {};
      this.resetValue();
      this.openAccountDialogVisible = false;
      this.$refs["accountForm"].resetFields();
    },
    //查看模态框确认事件
    bankHandleConfirm() {
      this.bankDialogData.visible = false;
    },
    //查看模态框关闭事件
    bankDialogClose() {
      this.bankDialogData.visible = false;
    },
    //查看银行账户信息
    viewButton(row) {
      let {id, trade_account, trade_bank, channel_name, account,new_account} = row;
      this.bankDialogData.title = `查看${id}`;
      this.bankForm.tradeAccount = trade_account;
      (this.bankForm.tradeBank = trade_bank);
      (this.bankForm.channelName = channel_name);
      (this.bankForm.new_account = new_account);
      this.bankForm.uid = account;
      console.log(this.bankForm, "row");
      this.bankDialogData.visible = true;
    },
    // 处理模态框，确定事件
    smsHandleConfirm() {
      // 调用组件的数据验证方法
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.is_open_sms == 1) {
            this.form.is_open_sms = 0;
          }
          if (this.form.is_open_sms == 0) {
            this.form.is_open_sms = 1;
          }
          this.form.template_desc = this.smsForm.template_desc;
          this.form.sms_alias_name = this.smsForm.sms_alias_name;
          this.smsDialogData.visible = false;
          this.smsForm = {};
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
    },
    // 处理短信模态框，关闭事件
    smsDialogClose() {
      this.smsForm = {};
      this.smsDialogData.visible = false;
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData();
      this.drawerData.visible = false;
      this.drawerData.loading = true;
      this.rolesList = [];
    },
    //单选操作
    selectRadio() {
      if (this.smsForm.template_id) {
        this.smsDialogData.loading = false;
        this.form.template_id = this.smsForm.template_id;
      }
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs["userForm"].validate((valid) => {
        if (valid) {
          if (this.userId) {
            if (this.$route.query.category != "channel") {
              if (!this.userFormData.password) {
                delete this.userFormData.password;
              }
              let args = {
                company_id: this.$route.query.id,
              };
              Object.assign(args, this.userFormData);
              this.updateStaff(this.userId, args);
            } else {
              let args = {
                op_channel_id: this.$route.query.id,
              };
              if (!this.userFormData.password) {
                delete this.userFormData.password;
              }
              Object.assign(args, this.userFormData);
              this.channelUpdateUser(this.userId, args);
            }
          } else {
            if (this.$route.query.category != "channel") {
              var queryChannelArgs;
              if (this.$route.query.id) {
                queryChannelArgs = {
                  company_id: this.$route.query.id,
                };
              } else {
                queryChannelArgs = {
                  company_id: this.companyId,
                };
              }
              Object.assign(queryChannelArgs, this.userFormData);
              this.createStaff(queryChannelArgs);
            } else {
              var opChannelArgs;
              if (this.$route.query.id) {
                opChannelArgs = {
                  op_channel_id: this.$route.query.id,
                };
              } else {
                opChannelArgs = {
                  op_channel_id: this.companyId,
                };
              }
              Object.assign(opChannelArgs, this.userFormData);
              this.channelSaveUser(opChannelArgs);
            }
          }
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
    },

    //增加渠道用户
    async channelSaveUser(data) {
      this.drawerData.loading = true
      this.drawerData.btnLoading = true
      let result = await this.$api.channelSaveUser(data);
      if (result) {
        this.drawerData.visible = false;
        this.drawerData.btnLoading = false
        this.userFormData = {};
        this.$refs["userForm"].resetFields();
        this.initUserList();
      }
      this.drawerData.loading = false
    },
    //编辑渠道用户
    async channelUpdateUser(id, data) {
        this.drawerData.loading = true
        this.drawerData.btnLoading = true
      let result = await this.$api.channelUpdateUser(id, data);
      if (result) {
          this.drawerData.visible = false
          this.drawerData.btnLoading = false
        this.initUserList();
        this.userFormData = {};
        this.$refs["userForm"].resetFields();
      }
      this.drawerData.loading = false
    },
    // form数据提交，请求接口
    async userFormSubmit() {
      this.drawerData.loading_text = "正在提交中……";
      this.drawerData.loading = true;
      let id = await this.$api.saveUser(this.userFormData);
      this.$nextTick(() => {
        this.drawerData.visible = false;
        this.drawerData.loading = false;
      });
      this.$nextTick(async () => {
        if (id) {
          this.initUserList();
        }
      });
      this.$nextTick(() => {
        this.$message.success("保存成功!");
      });
      this.initFormData();
    },
    // 初始化用户列表
    async initUserList() {
      this.userLoadingStaus = true;
      let pagingInfo = this.$refs["useApeTable"].getPagingInfo();
      var staffArgs;
      if (this.$route.query.id) {
        if (this.$route.query.category == "channel") {
          staffArgs = {
            op_channel_id: this.$route.query.id,
          };
        } else {
          staffArgs = {
            company_id: this.$route.query.id,
          };
        }
      } else {
        if (this.$route.query.category == "channel") {
          staffArgs = {
            op_channel_id: this.companyId,
          };
        } else {
          staffArgs = {
            company_id: this.companyId,
          };
        }
      }
      Object.assign(staffArgs, pagingInfo);
      if (this.$route.query.category == "channel") {
        let {data, pages} = await this.$api.channelUserList(staffArgs);
        this.$nextTick(() => {
          this.userList = data;
        });
        this.userPagingData.total = pages.total;
        this.offset = pages.offset;
        this.userLoadingStaus = false;
      } else {
        let {data, pages} = await this.$api.getStaffList(staffArgs);
        this.$nextTick(() => {
          this.userList = data;
        });
        this.userPagingData.total = pages.total;
        this.offset = pages.offset;
        this.userLoadingStaus = false;
      }
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.userFormData = {password: ""};
        this.$refs["userForm"].resetFields();
      });
    },
    // 生成SECRET
    randSecret() {
      let secret = this.$utils.randomString(6);
      this.$set(this.userFormData, "password", secret);
    },
    //添加用户
    async addUser() {
      this.isAdd = true;
      this.userId = null;
      this.userFormData = {
          password:'',
          type:0
      }
      this.drawerData.loading_text = "正在加载中……";
      this.drawerData.visible = true;
      this.drawerData.title = "添加用户";
      this.drawerData.loading = false;
    },
    /*设置税率*/
    setTaxRate(id, rate, rate_type) {
      this.dialogData.title = "设置税率";
      this.taxRateData.rate = rate;
      this.taxRateData.id = id;
      this.dialogData.visible = true;
      this.radioType = rate_type;
      //当前税率为0禁用单选按钮
      if (this.taxRateData.rate == 0) {
        this.rateNum = false
      } else {
        this.rateNum = true
      }
    },
    //设置税率
    async taxRateForm() {
      let args = {
        rate: this.taxRateData.taxRate,
        rate_type: this.radioType
      };

      /*      //输入税率为0禁用单选按钮
            if (this.taxRateData.taxRate ) {
              this.rateNum = true
            } else {
              this.rateNum = false
            }*/

      let result = await this.$api.saveRate(this.taxRateData.id, args);
      if (result) {
        if (this.$route.query.id) {
          this.subAccount(this.$route.query.id);
        } else {
          this.subAccount(this.companyId);
        }
      }
      this.taxRateData.taxRate = "";
      this.dialogData.visible = false;
    },
    //设置税率确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs["taxRateForm"].validate((valid) => {
        if (valid) {
          if (this.taxRateData.taxRate) {
            this.taxRateForm();
          }
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
    },
    //设置税率关闭事件
    dialogClose() {
      this.taxRateData.taxRate = "";
      this.dialogData.visible = false;
    },

    //编辑用户信息
    async editButton(data) {
      this.isAdd = false;
      this.userId = data.id;
      this.drawerData.visible = true;
      this.drawerData.title = "编辑用户(UID：" + data.id + ")";
      var editUserArgs;
      if (this.$route.query.id) {
        editUserArgs = {
          company_id: this.$route.query.id,
        };
      } else {
        editUserArgs = {
          company_id: this.companyId,
        };
      }
      if (this.$route.query.category == "channel") {
        this.$nextTick(() => {
          this.$set(this.userFormData, "mobile", data.mobile);
          this.$set(this.userFormData, "fullname", data.fullname);
          this.$set(this.userFormData, "user_type", data.user_type);
          this.$set(this.userFormData, "type", data.type);
          this.$set(this.userFormData, "email", data.email);
          this.drawerData.loading = false;
        });
      } else {
        this.viewStaff(data.id, editUserArgs);
      }
    },

    //获取员工详情（普通商户/api商户）
    async viewStaff(id, data) {
      let result = await this.$api.viewStaff(id, data);
      if (result) {
        this.$nextTick(() => {
          this.$set(this.userFormData, "mobile", result.mobile);
          this.$set(this.userFormData, "fullname", result.fullname);
          this.$set(this.userFormData, "password", result.password);
          this.$set(this.userFormData, "user_type", result.user_type);
          this.$set(this.userFormData, "email", result.email);
          this.drawerData.loading = false;
        });
      }
    },

    //编辑用户
    async updateStaff(id, data) {
        this.drawerData.loading = true
        this.drawerData.btnLoading = true
      let result = await this.$api.updateStaff(id, data);
      if (result) {
          this.drawerData.visible = false;
          this.drawerData.btnLoading = false
        this.initUserList();
        this.drawerData.visible = false;
        this.userFormData = {};
        this.$refs["userForm"].resetFields();
      }
      this.drawerData.loading = false
    },

    //创建用户
    async createStaff(data) {
        this.drawerData.loading = true
        this.drawerData.btnLoading = true
      let result = await this.$api.createStaff(data);
      if (result) {
        this.drawerData.visible = false;
        this.drawerData.btnLoading = false
        this.userFormData = {};
        this.initUserList();
        this.$refs["userForm"].resetFields();
      }
      this.drawerData.loading = false
    },

    //移除用户信息
    async deleteButton(id) {
      var deleteArgs;
      if (this.$route.query.category == "channel") {
        if (this.$route.query.id) {
          deleteArgs = {
            op_channel_id: this.$route.query.id,
          };
        } else {
          deleteArgs = {
            op_channel_id: this.companyId,
          };
        }
        await this.$api.channelMoveUser(id, deleteArgs);
      } else {
        if (this.$route.query.id) {
          deleteArgs = {
            user_id: id,
            company_id: this.$route.query.id,
          };
        } else {
          deleteArgs = {
            user_id: id,
            company_id: this.companyId,
          };
        }
        await this.$api.deleteStaff(deleteArgs);
      }
      this.initUserList();
    },

    //获取银行编码
    async getBankCode() {
      let result = await this.$api.getBankCode();
      if (result) {
        this.bankCodeList = result;
      }
    },
    //生成银行账户
    generateSubAccount(id, name) {
      this.company_id = id;
      this.company_name = name;
      this.outerVisible = true;
      this.tenantCategoryList();
      this.getBankCode();
    },
    // 切换页码操作
    async switchPaging() {
      console.log("分页");
      if (this.$route.query.id) {
        this.subAccount(this.$route.query.id);
      } else {
        this.subAccount(this.companyId);
      }
    },
    //用户列表切换页码操作
    async userSwitchPaging() {
      this.initUserList();
    },
    //获取短信模版数据
    async getSmsTemplate() {
      let result = await this.$api.getSmsTemplate();
      if (result) {
        this.smsData = result;
        this.smsDialogData.visible = true;
      }
    },
    //短信开关
    openSms() {
      if (this.form.is_open_sms == 1) {
        this.form.is_open_sms = 0;
        this.getSmsTemplate();
      }
      if (this.form.is_open_sms == 0) {
        this.form.is_open_sms = 0;
      }
    },
    //上传文件前的回调
    beforeUpload(load_text) {
      console.log("load_text", load_text);
      this.dialogData.loading = true;
    },

    // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    handUploadFile({url, filename, title}) {
      console.log("->上传成功....", url, filename, title);
      if (title == "合同") {
        this.form.contract_file_url = url;
      }
      if (title == "风控表") {
        this.form.risk_url = url.join(",");
      }
    },
    // 删除账户表单文件回调
    handleRemoveAccountFile() {
      console.log("->删除账户表单文件成功....");
    },
    // 上传账户表单文件成功回调
    handUploadAccountFile({url, filename, title}) {
      if (title == "转账场景图片") {
        // 单文件上传，url 是字符串
        this.accountForm.transfer_scene_pic = url;
        this.dataTransferScenePic = url;
      }
      if (title == "协议文件") {
        // 单文件上传，url 是字符串
        this.accountForm.transfer_scene_file = url;
        this.dataTransferSceneFile = url;
      }
      console.log("->上传账户表单文件成功....", this.accountForm, url, filename, title);
    },
    //跳转
    goTo(display_name, inSiderName) {
      this.display_name = display_name;
      this.inSiderName = inSiderName;
    },
    
    saveClick:debounce(function() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.$route.query.id && !this.$route.query.son) {
            this.editCompany();
          } else {
            this.formSubmit();
          }
        } else {
          this.$message.warning("请先正确填写信息");
          return false;
        }
      });
    },2000,{leading:true,trailing:false}),

    //  对form.name 进行符号修改
    formatName(name) {
      name = name.replace(/[(]/g, "（");
      name = name.replace(/[)]/g, "）");
      return name;
    },
    //保存表单
    async formSubmit() {
		console.log('formSubmit')
		if(typeof this.form.risk_url==='object') {
			this.form.risk_url = this.form.risk_url.join(",");
		}
      if (this.$route.query.category == "ordinary") {
        //普通商户保存
        if (this.$route.query.son) {
          this.form.parent_id = this.$route.query.id;
        } else {
          this.form.parent_id = 0;
        }
		if(typeof this.form.risk_url==='object') {
			this.form.risk_url = this.form.risk_url.join(",");
		}
        const ordinaryArgs = {
          parent_id: this.form.parent_id,
          // name: this.form.name,
          name: this.formatName(this.form.name),
          remark: this.form.remark,
          account: this.form.account,
          legal_person: this.form.legal_person,
          taxpayer: this.form.taxpayer,
          legal_phone: this.form.legal_phone,
          company_phone: this.form.company_phone,
          address: this.form.address,
          receiver_fullname: this.form.receiver_fullname,
          receiver_phone: this.form.receiver_phone,
          bank: this.form.bank,
          email: this.form.email,
          bank_name: this.formatName(this.form.name),
          is_open_sms: this.form.is_open_sms,
          template_id: this.form.template_id,
          template_desc: this.form.template_desc,
          sms_alias_name: this.form.sms_alias_name,
          contract_file_url: this.form.contract_file_url,
          risk_url: this.form.risk_url,
          is_import: this.form.is_import,
          is_openid: 0,
          category_list:this.form.category_list,
		sign_type: this.form.sign_type,
        };
        let result = await this.$api.createCompany(ordinaryArgs);
        if (result) {
          this.$message.success("保存成功");
          this.companyId = result.company_id;
          this.companyName = this.form.name;
          this.$router.push({
            path: `/company/${this.companyId}/edit`,
            query: {
              category: "ordinary",
              id: this.companyId,
              name: this.companyName,
            },
          });
          this.isAbleUserBtn = false;
          this.isAbleBankBtn = false;
        }
      }
      if (this.$route.query.category == "channel") {
        //渠道商户保存
		if(typeof this.form.risk_url==='object') {
			this.form.risk_url = this.form.risk_url.join(",");
		}
        const channelArgs = {
          parent_id: 0,
          name: this.formatName(this.form.name),
          account: this.form.account,
          taxpayer: this.form.taxpayer,
          company_phone: this.form.company_phone,
          address: this.form.address,
          email: this.form.email,
          receiver_fullname: this.form.receiver_fullname,
          receiver_phone: this.form.receiver_phone,
          bank: this.form.bank,
          bank_name: this.formatName(this.form.name),
          contract_file_url: this.form.contract_file_url,
          risk_url: this.form.risk_url,
          rate: this.form.rate,
          is_import: this.form.is_import,
          is_openid: 0,
          category_list:this.form.category_list
        };
        let result = await this.$api.createChannel(channelArgs);
        if (result) {
          this.$message.success("保存成功");
          this.companyId = result;
          this.companyName = this.formatName(this.form.name);
          this.$router.push({
            path: `/channel/${this.companyId}/edit`,
            query: {category: "channel", id: this.companyId},
          });
          this.isAbleUserBtn = false;
          this.isAbleBankBtn = false;
        }
      }
      if (this.$route.query.category == "member") {
        //api商户保存
        if (this.$route.query.son) {
          this.form.parent_id = this.$route.query.id;
        } else {
          this.form.parent_id = 0;
        }
		if(typeof this.form.risk_url==='object') {
			this.form.risk_url = this.form.risk_url.join(",");
		}
        const apiArgs = {
          category_ids: this.form.category,
          parent_id: this.form.parent_id,
          name: this.formatName(this.form.name),
          remark: this.form.remark,
          account: this.form.account,
          legal_person: this.form.legal_person,
          taxpayer: this.form.taxpayer,
          legal_phone: this.form.legal_phone,
          company_phone: this.form.company_phone,
          address: this.form.address,
          receiver_fullname: this.form.receiver_fullname,
          receiver_phone: this.form.receiver_phone,
          bank: this.form.bank,
          bank_name: this.formatName(this.form.name),
          is_open_sms: this.form.is_open_sms,
          template_id: this.form.template_id,
          template_desc: this.form.template_desc,
          sms_alias_name: this.form.sms_alias_name,
          contract_file_url: this.form.contract_file_url,
          risk_url: this.form.risk_url,
          is_openid: 1,
          is_import: this.form.is_import,
          category_list:this.form.category_list,
		sign_type: this.form.sign_type,
        };
        let result = await this.$api.createCompany(apiArgs);
        if (result) {
          this.$message.success("保存成功");
          this.companyId = result.company_id;
          this.companyName = this.formatName(this.form.name);
          this.$router.push({
            path: `/merchant/${this.companyId}/edit`,
            query: {category: "member", id: this.companyId},
          });
          this.isAbleUserBtn = false;
          this.isAbleBankBtn = false;
        }
      }
    },
    //编辑公司
    async editCompany() {
		console.log('editCompany')
		if(typeof this.form.risk_url==='object') {
		this.form.risk_url = this.form.risk_url.join(",");
		}
      if (this.$route.query.category == "ordinary" && !this.$route.query.son) {
		if(typeof this.form.risk_url==='object') {
		this.form.risk_url = this.form.risk_url.join(",");
		}
        const ordinaryArgs = {
          parent_id: this.form.parent_id,
          name: this.formatName(this.form.name),
          remark: this.form.remark,
          account: this.form.account,
          legal_person: this.form.legal_person,
          taxpayer: this.form.taxpayer,
          legal_phone: this.form.legal_phone,
          company_phone: this.form.company_phone,
          address: this.form.address,
          receiver_fullname: this.form.receiver_fullname,
          receiver_phone: this.form.receiver_phone,
          bank: this.form.bank,
          bank_name: this.formatName(this.form.name),
          is_open_sms: this.form.is_open_sms,
          template_id: this.form.template_id,
          template_desc: this.form.template_desc,
          sms_alias_name: this.form.sms_alias_name,
          contract_file_url: this.form.contract_file_url,
          risk_url: this.form.risk_url,
          is_import: this.form.is_import,
          email: this.form.email,
          is_openid: 0,
          sign_type: this.form.sign_type,
          category_list:this.form.category_list
        };

        let result = await this.$api.updateCompany(
          this.$route.query.id,
          ordinaryArgs
        );
        console.log(ordinaryArgs);
        if (result) {
          this.$message.success("修改成功");
        } else {
          this.$message.error(result.message);
        }
      }
      if (this.$route.query.category == "channel" && !this.$route.query.son) {
        // 根据不同传不同的参数
        if (this.taxRateType == 1) {
          this.Taxratedatas = [];
        } else if (this.taxRateType == 2) {
          this.gradstaxRate.rate = this.form.rate;
          this.gradsdata.push(this.gradstaxRate);
          this.Taxratedatas = this.gradsdata;
          this.Taxratedatas.map((item) => {
            item.money = Number(item.money)
            item.rate = Number(item.rate)

            if (!item.money) {
              item.money = 0
            }
          })
        }
if(typeof this.form.risk_url==='object') {
		this.form.risk_url = this.form.risk_url.join(",");
		}
        const channelArgs = {
          name: this.formatName(this.form.name),
          account: this.form.account,
          taxpayer: this.form.taxpayer,
          company_phone: this.form.company_phone,
          address: this.form.address,
          email: this.form.email,
          receiver_fullname: this.form.receiver_fullname,
          receiver_phone: this.form.receiver_phone,
          bank: this.form.bank,
          bank_name: this.formatName(this.form.name),
          contract_file_url: this.form.contract_file_url,
          rate: this.form.rate,
          is_import: this.form.is_import,
          is_openid: 0,
          type: this.taxRateType,
          key: this.Taxratedatas,
          category_list:this.form.category_list
        };
        let result = await this.$api.updateChannel(
          this.$route.query.id,
          channelArgs
        );
        if (result) {
          this.$message.success("修改成功");
        }
      }
      if (this.$route.query.category == "member" && !this.$route.query.son) {
		if(typeof this.form.risk_url==='object') {
		this.form.risk_url = this.form.risk_url.join(",");
		}
        const apiArgs = {
          category_ids: this.form.category,
          parent_id: this.form.parent_id,
          name: this.formatName(this.form.name),
          remark: this.form.remark,
          account: this.form.account,
          legal_person: this.form.legal_person,
          taxpayer: this.form.taxpayer,
          legal_phone: this.form.legal_phone,
          company_phone: this.form.company_phone,
          address: this.form.address,
          receiver_fullname: this.form.receiver_fullname,
          receiver_phone: this.form.receiver_phone,
          bank: this.form.bank,
          bank_name: this.formatName(this.form.name),
          is_open_sms: this.form.is_open_sms,
          template_id: this.form.template_id,
          template_desc: this.form.template_desc,
          sms_alias_name: this.form.sms_alias_name,
          contract_file_url: this.form.contract_file_url,
          risk_url: this.form.risk_url,
          is_openid: 1,
          email: this.form.email,
          is_import: this.form.is_import,
          sign_type: this.form.sign_type,
          category_list:this.form.category_list
        };
        let result = await this.$api.updateCompany(
          this.$route.query.id,
          apiArgs
        );
        if (result) {
          this.$message.success("修改成功");
        }
      }
    },

    //普通商户详情
    async viewCompany(id) {
      let result = await this.$api.viewCompany(id);
      this.companyName = result.name;
      if (result.contract_file_url) {
        this.dataContractUrl = result.contract_file_url;
      }
      if (result.risk_url) {
        this.dataRiskUrl = result.risk_url.split(',');
        result.risk_url = result.risk_url.split(',')||[];
      }
      this.form = result;
      this.form.category = result.category_ids;
      this.form_category_list = (result.category_list || []).map(item => item.category_id);
      console.log(this.form,'表单数据')
      if (result.is_edit) {
        this.is_edit = false;
        this.isAbleBankBtn = false;
        this.isAbleUserBtn = false;
      } else {
        this.is_edit = true;
        this.isAbleBankBtn = true;
        this.isAbleUserBtn = true;
      }
    },
  },

  async mounted() {
    // this.getInvoiceCategoryList();
    this.query = this.$route.query
    this.enumList = await this.$api.getCategoryEnumList("task");
    if (this.$route.query.category == "ordinary") {
      if (this.$route.query.id && !this.$route.query.son) {
        this.isAbleBankBtn = false;
        this.isAbleUserBtn = false;
        this.viewCompany(this.$route.query.id);
      }
    }
    if (this.$route.query.category == "channel") {
      if (this.$route.query.id) {
        this.isAbleBankBtn = false;
        this.isAbleUserBtn = false;
        this.channelView(this.$route.query.id);
        this.showSL = true;
      }
    }
    if (this.$route.query.category == "member") {
      if (this.$route.query.id && !this.$route.query.son) {
        this.isAbleBankBtn = false;
        this.isAbleUserBtn = false;
        this.viewCompany(this.$route.query.id);
      }
    }
    if (this.$route.query.id) {
      this.initUserList(); //初始化用户列表
      if (!this.$route.query.son) {
        this.subAccount(this.$route.query.id);
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
	.htFile {
		display block float right
	}

	.ladderTaxrate {
		margin-left: 70px;
	}

	.ladder {
		display: flex;
		min-width: 500px;
		justify-content: flex-start;
		align-items: center;
	}

	.elItem {
		margin-right 40px;
	}


	.ladder>i {
		display: block;
		margin-bottom: 18px;
	}

	.transverse {
		display: flex;
	}

	.contract {
		height: 110px !important;
	}

	/deep/ .account-wrapper .el-dialog__body {
		padding: 30px 55px;
	}

	.manage {
		margin-top: 0;
		margin-left: 10px;
	}

	/deep/ .set .el-form-item__content {
		margin-left: 96px;
	}

	.form-alert {
		color: #f56c6c;
		font-size: 14px;
	}

	.bank {
		padding: 10px 0 0px 0;
	}

	.bank-wrapper {
		padding: 24px 20px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.accountTips {
		margin-bottom: 30px;
	}

	/deep/ .form-alert .el-alert__content.el-alert--warning.is-light {
		background: #fff !important;
	}

	/deep/ .accountTips .el-alert--success.is-light {
		padding: 20px;
	}

	/deep/ .accountTips .el-alert__title {
		font-size: 20px;
		padding-left: 10px;
	}

	.change-acct {
		display: flex;
	}

	.settlement-select {
		width: 269px;
	}

	/deep/ .set .el-form-item__content {
		margin-left: 96px;
	}

	/deep/ .sub-account .el-form-item {
		margin-bottom: 0;
	}

	/deep/ .el-form.sub-account {
		padding: 0 50px;
	}

	.el-button {
		margin-right: 4px;
		margin-bottom: 4px;
	}

	.upload-contract {
		width: 75%;
		margin-left: 9%;
		margin-top: -50px;
	}

	.switch {
		height: 50px;
		display: flex;
	}

	.company-bottom {
		width: 70%;
		margin: 0 auto;
	}

	.address-select {
		width: 85%;
	}

	.manage-bill-btn {
		margin-left: 20px;
	}

	.bill-info-form {
		// margin-top: 40px;
	}

	.bill-info {
		// display: flex;
		// flex-direction: column;
		width: 90%;
		height: 80px;
		padding: 20px 0;
	}

	.bill-info-title {
		width: 100%;
	}

	.bill-mail-info {
		width: 70%;
		margin: 0px auto;
	}

	/deep/ .bill-mail-info .el-form-item {
		display: flex;
		flex-direction: row;
	}

	/deep/ .el-form--label-top .el-form-item__label {
		position: relative;
	}

	/deep/ .bill-info-form .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before,
	/deep/ .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before {
		position: absolute;
		left: -10px;
	}

	/deep/ .bill-mail-info .el-form-item .el-form-item__content {
		width: 100%;
	}

	.mail-info-title {
		width: 100px;
	}

	.business-address {
		display: flex;
	}

	.save-btn-wrapper {
		display: flex;
		justify-content: flex-end;
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.priceIcon {
		font-size: 30px;
		color: #e6a23c;
		margin-top: 3px;
		margin-left: 10px;
	}

	.alert {
		margin-top: 40px;
	}

	.steps {
		width: 100%;
		height: 41px;
		background-color: #F0F0F0;
		line-height: 41px;
		padding: 0 10px;
		font-weight: bolder;
	}

	/deep/ .steps .el-steps--simple {
		background: #fff;
		padding: 13px 0%;
	}

	/deep/ .steps .el-steps--simple .el-step__title {
		width: 80%;
		text-align: center;
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		background: #959595;
		color: #fff;
	}

	/deep/ .steps .el-step.is-simple:not(:last-of-type) .el-step__title {
		max-width: 80%;
	}

	/deep/ .steps .el-step__head {
		display: none;
	}

	/deep/ .steps .el-steps--simple .el-step__title.is-success {
		background: #00B79E;
	}

	.icon {
		font-size: 30px;
	}

	.fenge {
		margin-top: 50px;
		padding-top: 30px;
		width: 99%;
	}

	.mail-wrapper {
		margin-top: 80px;
		padding-top: 40px;
		padding-bottom: 20px;
		border-top: 1px solid #dcdfe6;
		border-bottom: 1px solid #dcdfe6;
	}

	.tax-wrapper {
		display: flex;
	}

	// .tax-rate.el-input.el-input-group.el-input-group--append {
	// margin-left: 35% !important;
	// margin-top: -48px !important;
	// }
	.current-tax {
		margin-left: 10%;
		height: 40px;
		line-height: 40px;
	}

	.table-header {
		margin-bottom: 12px;
	}

	.drag-handle {
		font-size: 24px;
		cursor: pointer;
	}

	.el-popover .el-checkbox-group .el-checkbox {
		margin-left: 0px;
		margin-right: 12px;
	}

	.el-select>.el-input {
		width: 300px;
	}

	#generate {
		margin-bottom: -10px;
		margin-left: 4px;
	}

	.qr-code {
		width: 266px;
		height: 266px;
		margin: 0 auto;
		border: 1px solid black;
	}

	.qr-code-tips {
		text-align: center;
		color: #EE0A0A;
	}

	.link-title {
		text-align: center;
		padding-bottom: 10px;
		color: #67C23A;
	}

	.copyBtn {
		position: relative;
		top: -15px;
		left: 84%;
	}

	.remarks {
		color #F56C6C
	}

	.transfer-wrapper {
		display: flex;
		upload-file {
			flex: 1;
		}
		.desc {
			margin-left: 10px;
			font-size: 14px;
			color: #F56C6C;
			line-height: 20px;
		}
	}

	.transfer-scene-pic-title {
		margin-left: 10px;
		font-size: 14px;
		color: #999;
	}

	.settlement-textarea {
		width: 100%;
	}
</style>
